import  { useState, useMemo,useEffect } from "react";
import { Button,Container } from "reactstrap";
import { useQuery, useQueryClient } from "react-query";
import { Spin,Skeleton } from "antd";
import toast from "react-hot-toast";
import { createEspaceClient, deleteMerchent, getAllMerchent, getBusinessMarchandById, getMerchantTotalRevenu } from "../services/merchentApi.js";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import { useNavigate } from "react-router-dom";
import empty from "../../../../assets/images/emptyMarchand.png";
import { getAverageMonthlyVolume, getStatsByMerchantId } from "../../dashboard/services/homeAdminApi.js";
import { getMetricsByBusIdPercountryCode } from "../../../developer/services/developerApi.js";
import { getAllDevelopers } from "../../business/services/developerApi.js";
import { saveUserToSessionStorage } from "../../../auth/services/authApi.js";
import { setAuthorization } from "../../../../helpers/api_helper.js";
import ReconciliationHebdomadaire from "../component/ReconciliationHebdomadaire.js";
import VerificationJournalier from "../component/verification-journalier.js";
const Rapport = () => {
    const [selectedMarchand, setSelectedMarchand] = useState(null);
    const [selectedCountryCode, setSelectedCountryCode] = useState("");
    const [selectedBusiness, setSelectedBusiness] = useState(null);
    const { data: stats } = useQuery("stats", getAverageMonthlyVolume);
    const { isLoadingD, isErrorD, errorD, data: developers } = useQuery("developers", getAllDevelopers)
    const busId = selectedBusiness?.id;
    const cc = selectedCountryCode;
   const { data: metrics, isLoading: isLoadingMetric, isError: isErrorMetric, error: errorMetric } = useQuery(
       ["metrics", busId, cc],
       () => getMetricsByBusIdPercountryCode(busId, cc),
       { enabled: !!busId && !!cc }
     );
     const { countryBalance } = metrics || {};
    const { data: statsMerchant, isLoading: isLoadingMerchantStats } = useQuery(
       ["merchantStats", selectedMarchand],
       () => getStatsByMerchantId(selectedMarchand),
       {
         enabled: !!selectedMarchand, // ❗ n'appelle que quand un marchand est sélectionné
       }
     );
   const { isLoadingM, isErrorM, errorM, data: merchants } = useQuery("merchants", getAllMerchent);
   const marchandsActifs = Array.isArray(merchants)
  ? merchants.filter((m) => m.active === true).length
  : 0;
  const activeMerchants = selectedMarchand ? statsMerchant?.activeMerchants : marchandsActifs;
    const pourcentageMActif = selectedMarchand
    ? ((statsMerchant?.activeMerchants*100)/marchandsActifs).toFixed(0)
    : merchants?.length
      ? ((marchandsActifs * 100) / merchants.length).toFixed(0)
      : 0;
      
      //nombre de business pour un marchand 
       const [merchantBusiness, setBusinessMerchant] = useState(null);
      useEffect(() => {
        const fetchBusinessMerchant = async () => {
          try {
            const data = await getBusinessMarchandById(selectedMarchand);
            console.log("Réponse business marchand:", data);
            setBusinessMerchant(data);
          } catch (error) {
            console.error("Erreur lors du chargement du business du marchand :", error);
          }
        };
        if (selectedMarchand) {
          fetchBusinessMerchant();
        }
      }, [selectedMarchand]);
      //developer
    const activeBusinesses = selectedMarchand ? statsMerchant?.activeDeveloperAccounts : stats?.activeDeveloperAccounts;
    const pourcentageActifBusiness = selectedMarchand
    ? ((statsMerchant?.activeDeveloperAccounts*100)/merchantBusiness?.length).toFixed(0)
    : developers?.length
    ? ((stats?.activeDeveloperAccounts * 100) / developers.length).toFixed(0)
    : 0;
const [totalRevenu, setTotalRevenu]=useState(null);
const [loadingTotalRevenu, setLoadingTotalRevenu]=useState(null);
useEffect(() => {
  const loadTotalRevenu = async () => {
    try {
      setLoadingTotalRevenu(true);
      const data = await getMerchantTotalRevenu();
      setTotalRevenu(data);
    } catch (error) {
      console.error("Erreur commission :", error);
      setTotalRevenu(null);
    } finally {
      setLoadingTotalRevenu(false);
    }
  };
  loadTotalRevenu();
}, []);
const navigate = useNavigate();
 const [searchTerm, setSearchTerm] = useState("");
const [filterValues, setFilterValues] = useState(null);
const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedMerchant, setSelectedMerchant] = useState(null);
const queryClient = useQueryClient();
document.title = `Business | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
const [modalState, setModalState] = useState({ type: null, data: null });
const [isDeleting, setIsDeleting] = useState(false);
const currentuser = JSON.parse(sessionStorage.getItem('authAdmin'));
const { isLoading, isError, error, data: merchents } = useQuery("merchents", getAllMerchent);
const tabs = ['Tous', 'Actives', 'En cours', 'Désactivés', 'Rejetés'];
const [activeTab, setActiveTab] = useState('Tous');
const [sortOrder, setSortOrder] = useState("asc");
 const handleApplyFilters = (filters) => {
  setFilterValues(filters);
};
const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const filteredMerchents = useMemo(() => {
    if (!merchents || merchents.length === 0) return [];
    let result = [...merchents];
    if (filterValues) {
        if (filterValues.active!=="") {
          result = result.filter((t) => t.active === filterValues.active);
        } 
        if (filterValues.countrie) {
          result = result.filter((t) => t.country === filterValues.countrie);
        }
        if (filterValues.createdDate) {
            result = result.filter((t) => {
              const txDate = new Date(t.createdDate).toISOString().slice(0, 10);
              return txDate === filterValues.createdDate;
            });
          }
      }
        if (sortOrder === "asc") {
            result.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
          } else {
            result.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
          }

      if (!searchTerm) return result 
        const lowerSearch = searchTerm.toLowerCase();
          result = result.filter(mer =>{
          return (
        mer.firstName?.toLowerCase().includes(lowerSearch) ||
        mer.lastName?.toLowerCase().includes(lowerSearch) ||
        mer.phoneNumber?.toLowerCase().includes(lowerSearch)
      );
  });
      
      return result;
    
  }, [merchents,searchTerm,filterValues,sortOrder]);
  const openModal = (type, data = null) => {
    setModalState((prevState) => (prevState.type === type ? { type: null, data: null } : { type, data }));
  };

  const handleEdit = (merchent) => {
    openModal("edit", merchent);
  };

  const handleDetail = (merchent) => {
  navigate(`/marchands/${merchent.id}`);
};

  const handleValidate = (merchent) => {
    openModal("valid", merchent);
  };

  const handleRappel = (action, merchant) => {
  setModalState({
    type: "rappel",
    action,       
    data: merchant 
  });
};
  const openDeleteConfirmModal = (merchentId) => {
    const merchentToDelete = merchents.find(merchent => merchent.id === merchentId);
    if (merchentToDelete) {
      setModalState({
        type: "delete",
        data: { merchentId, merchentName: merchentToDelete.businessName },
      });
    }
  };

  const closeDeleteConfirmModal = () => {
    setModalState({ type: null, data: null });
  };
  const handleDelete = async (merchentId) => {
    setIsDeleting(true);
    try {
      await deleteMerchent(merchentId);
      queryClient.invalidateQueries("merchents");
      toast.success("Le business a été supprimé avec succès");
    } catch (error) {
      toast.error(`😔 Erreur lors de la suppression du business : ${error?.message || error}`);
    } finally {
      setIsDeleting(false);
      closeDeleteConfirmModal();
    }
  };
const [isMobile, setIsMobile] = useState(false);
useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  handleResize(); 
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);
  const columnsJournalier = useMemo(() => [
   {
  Header: "ID Rapport",
  accessor: "lastName",
  filterable: false,
  Cell: ({ row }) => {
    const { firstName, lastName, profilePhoto } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={profilePhoto || defaultAvatar}
          alt=''
          style={{
            width: 29,
            height: 29,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
        <span>{firstName} {lastName}</span>
      </div>
    );
  }
},
 {
  Header: "Nom Rapport",
  accessor: "lastNamez",
  filterable: false,
  Cell: ({ row }) => {
    const { firstName, lastName, profilePhoto } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={profilePhoto || defaultAvatar}
          alt=''
          style={{
            width: 29,
            height: 29,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
        <span>{firstName} {lastName}</span>
      </div>
    );
  }
},
    {
    Header: "Solde interne",
    accessor: "kycVerified",
    Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5", 
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value === true) {
        label = "KYC ACTIVER";
         icon = "✓";
        style.backgroundColor = "#EBFFEA"; 
        style.color = "#349C32";           
      } else if (value === false) {
        label = "KYC DÉSACTIVER";
         icon = "🚫"; 
        style.backgroundColor = "#FFF0F0";
        style.color = "#D41C1C";
      }
      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    }, 
     {
    Header: "Solde externe",
    accessor: "active",
    Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5", 
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value === true) {
        label = "Actif";
         icon = "✓";
        style.backgroundColor = "#EBFFEA"; 
        style.color = "#349C32";           
      } else if (value === false) {
        label = "Inactif";
         icon = "✓"; 
        style.backgroundColor = "#FFF0F0";
        style.color = "#D41C1C";
      }
      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    }, 
    {
  Header: "Écart",
  accessor: "lastNamezz",
  filterable: false,
  Cell: ({ row }) => {
    const { firstName, lastName, profilePhoto } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        
        <span>{firstName} {lastName}</span>
      </div>
    );
  }
},   
    {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
          
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                cursor: "pointer",
                border: "1px solid #00000014",
              }}
            onClick={(e) => {
          e.stopPropagation();
          setSelectedMerchant(row.original); 
          const rect = e.currentTarget.getBoundingClientRect();
              setModalPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX -250,
            });
          setIsModalOpen(true);
        }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="12" r="2" fill="#21272A" />
                <circle cx="12" cy="12" r="2" fill="#21272A" />
                <circle cx="18" cy="12" r="2" fill="#21272A" />
              </svg>
            </div>
          </div>
        );
      },
      filterable: false,
    },
  ], [handleEdit, openDeleteConfirmModal, handleDetail, handleValidate, handleRappel]);
    const columnsHebdomadaire = useMemo(() => [
   {
  Header: "ID Rapport",
  accessor: "lastName",
  filterable: false,
  Cell: ({ row }) => {
    const { firstName, lastName, profilePhoto } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={profilePhoto || defaultAvatar}
          alt=''
          style={{
            width: 29,
            height: 29,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
        <span>{firstName} {lastName}</span>
      </div>
    );
  }
},
 {
  Header: "Nom Rapport",
  accessor: "lastNamez",
  filterable: false,
  Cell: ({ row }) => {
    const { firstName, lastName, profilePhoto } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={profilePhoto || defaultAvatar}
          alt=''
          style={{
            width: 29,
            height: 29,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
        <span>{firstName} {lastName}</span>
      </div>
    );
  }
},
{
  Header: "Période",
  accessor: "createdDate",
  Cell: ({ value }) =>
    value
      ? new Date(value).toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "-",
  filterable: false,
},
    {
    Header: "Solde plateforme",
    accessor: "kycVerified",
    Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5", 
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value === true) {
        label = "KYC ACTIVER";
         icon = "✓";
        style.backgroundColor = "#EBFFEA"; 
        style.color = "#349C32";           
      } else if (value === false) {
        label = "KYC DÉSACTIVER";
         icon = "🚫"; 
        style.backgroundColor = "#FFF0F0";
        style.color = "#D41C1C";
      }
      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    }, 
     {
    Header: "Solde business",
    accessor: "active",
    Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5", 
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value === true) {
        label = "Actif";
         icon = "✓";
        style.backgroundColor = "#EBFFEA"; 
        style.color = "#349C32";           
      } else if (value === false) {
        label = "Inactif";
         icon = "✓"; 
        style.backgroundColor = "#FFF0F0";
        style.color = "#D41C1C";
      }

      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    }, 
    {
  Header: "Écart",
  accessor: "lastNamezz",
  filterable: false,
  Cell: ({ row }) => {
    const { firstName, lastName, profilePhoto } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        
        <span>{firstName} {lastName}</span>
      </div>
    );
  }
},  
  {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
          
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                cursor: "pointer",
                border: "1px solid #00000014",
              }}
            onClick={(e) => {
          e.stopPropagation();
          setSelectedMerchant(row.original); 
          const rect = e.currentTarget.getBoundingClientRect();
              setModalPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX -250,
            });
          setIsModalOpen(true);
        }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="12" r="2" fill="#21272A" />
                <circle cx="12" cy="12" r="2" fill="#21272A" />
                <circle cx="18" cy="12" r="2" fill="#21272A" />
              </svg>
            </div>
          </div>
        );
      },
      filterable: false,
    },
  ], [handleEdit, openDeleteConfirmModal, handleDetail, handleValidate, handleRappel]);
  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      {tabs.map((tab) => (
        <Button
          key={tab}
          onClick={() => handleTabChange(tab)}
          className={`btn ${activeTab === tab ? 'active-tab' : 'btn-light'}`}
        >
          {tab}
        </Button>
      ))}
    </div>
  );
  const [tabLoading, setTabLoading] = useState(false);
   const tab = ["Vérification fonds providers (Journalier)", "Réconciliation interne (Hebdomadaire)"];
       const [activeTableau, setActiveTableau] = useState("Vérification fonds providers (Journalier)");
       const handleTabClick = (tab) => {
        setTabLoading(true);
        setActiveTableau(tab);
        setTimeout(() => {
          setTabLoading(false);
        }, 600); 
      };
  const HeaderTable = () => (
  <div className="d-flex flex-column align-items-start gap-3 w-100">
    <div className='title-page mb-2'>
      Rapports financiers
      <span className="lenght">
            {isLoading ? (
              <Spin size="small" />
            ) : !merchants?.length ? (
              "0"
            ) : (
              merchants.length
            )}
      </span>
    </div>
 <div
    style={{
      display: "flex",
      flexWrap: "wrap",            
      justifyContent: "flex-start", 
      alignItems: "center",
      gap: "16px",               
      marginTop: "10px",
      marginBottom: "5px",
      width: "100%",
    }}
    className="mb-3"
  >
    {["Vérification fonds providers (Journalier)","Réconciliation interne (Hebdomadaire)"
    ].map(
      (tab) => (
        <div
          key={tab}
          onClick={() => handleTabClick(tab)}
          style={{
            cursor: "pointer",
            color: activeTableau === tab ? "#3761FF" : "#00000073",
            fontWeight: 400,
            fontSize: "16px",
            fontFamily: "Poppins",
            fontStyle: "normal",
            position: "relative",
            paddingBottom: "6px",
            transition: "color 0.3s ease",
          }}
        >
          {tab}
          {activeTableau === tab && (
            <div
              style={{
                height: "3px",
                backgroundColor: "#3761FF",
                width: "100%",
                position: "absolute",
                bottom: 0,
                left: 0,
                borderRadius: "2px",
              }}
            />
          )}
        </div>
      )
    )}
  </div>
  </div>
);
const handleConnectClient = async (merchant) => {
  try {
    const email = merchant.email;
    const adminSession = sessionStorage.getItem("authAdmin");
    if (adminSession) {
      localStorage.setItem("backupAdmin", adminSession);
    }
    const data = await createEspaceClient(email);
    const merchantToken = data?.token;
    if (!merchantToken) throw new Error("Token marchand introuvable");
    saveUserToSessionStorage(data);
    setAuthorization(data.token, false);
      sessionStorage.removeItem("authAdmin");
    window.location.href = `/merchant/dashboard`;
  } catch (error) {
    console.error("❌ Impossible de se ace client :", error);
    toast.error("Impossible de se ace client !");
  }
};
  return (
      <div className="page-content">
    <Container fluid>
      <HeaderTable />
      {tabLoading ? (
        <div style={{ padding: "20px" }}>
          <Skeleton active paragraph={{ rows: 6 }} />
        </div>
      ) : (
       <>
   {activeTableau === "Vérification fonds providers (Journalier)" && (
  <VerificationJournalier
    searchTerm={searchTerm}
    setSearchTerm={setSearchTerm}
    openModal={openModal}
    renderTabs={renderTabs}
    columnsJournalier={columnsJournalier}
    filteredMerchents={filteredMerchents}
    isLoading={isLoading}
    isError={isError}
    empty={empty}
    modalState={modalState}
    setModalState={setModalState}
    selectedMerchant={selectedMerchant}
    setIsModalOpen={setIsModalOpen}
    isModalOpen={isModalOpen}
    modalPosition={modalPosition}
    handleDetail={handleDetail}
    currentuser={currentuser}
    HeaderTable={HeaderTable}
  />
)}
  {activeTableau === "Réconciliation interne (Hebdomadaire)" && (
  <ReconciliationHebdomadaire
    searchTerm={searchTerm}
    setSearchTerm={setSearchTerm}
    openModal={openModal}
    renderTabs={renderTabs}
    columnsHebdomadaire={columnsHebdomadaire}
    filteredMerchents={filteredMerchents}
    isLoading={isLoading}
    isError={isError}
    empty={empty}
    modalState={modalState}
    setModalState={setModalState}
    selectedMerchant={selectedMerchant}
    setIsModalOpen={setIsModalOpen}
    isModalOpen={isModalOpen}
    modalPosition={modalPosition}
    handleDetail={handleDetail}
    handleConnectClient={handleConnectClient}
    handleRappel={handleRappel}
    handleDelete={handleDelete}
    closeDeleteConfirmModal={closeDeleteConfirmModal}
    isDeleting={isDeleting}
    currentuser={currentuser}
    handleApplyFilters={handleApplyFilters}
    setSortOrder={setSortOrder}
    HeaderTable={HeaderTable}
  />
)}
  </>
  )}
      </Container>
      </div>
   
  );
};

export default Rapport;
